import React, { useEffect } from 'react'

const VerticalTimeline = ({height = 420}) => {
  // Simple animated vertical timeline SVG with pulsing nodes
  useEffect(() => {
    // no-op, placeholder if we want JS animations later
  }, [])

  const nodes = [0.12, 0.42, 0.72]

  return (
    <div className="absolute left-0 top-8 hidden lg:block" style={{width: 140, height}} aria-hidden>
      <svg width="140" height={height} viewBox={`0 0 140 ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="gradLine" x1="0%" x2="100%">
            <stop offset="0%" stopColor="#ff6a3d" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#7b2ff7" stopOpacity="0.9" />
          </linearGradient>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="6" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* vertical base line */}
        <line x1="70" y1="10" x2="70" y2={height-10} stroke="url(#gradLine)" strokeWidth="3" strokeLinecap="round" style={{filter: 'url(#glow)'}} />

        {/* animated dash over line */}
        <line x1="70" y1="10" x2="70" y2={height-10} stroke="#fff" strokeWidth="1" strokeDasharray="8 8" strokeOpacity="0.06" />

        {/* nodes */}
        {nodes.map((t, i) => {
          const y = Math.round(10 + t * (height - 20))
          return (
            <g key={i} transform={`translate(70, ${y})`}>
              <circle r="14" fill="#0f1724" stroke="#ff704c" strokeWidth="2.5" />
              <circle r="5" fill="#fff" opacity="0.9">
                <animate attributeName="r" values="4;6;4" dur={`${1.8 + i*0.3}s`} repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.6;1;0.6" dur={`${1.8 + i*0.3}s`} repeatCount="indefinite" />
              </circle>
            </g>
          )
        })}

        {/* connector curve to the right (towards the cards/title) */}
        <path d={`M70 ${Math.round(height*0.15)} C 110 ${Math.round(height*0.12)} 120 ${Math.round(height*0.15)} 140 ${Math.round(height*0.2)}`} stroke="url(#gradLine)" strokeWidth="2" fill="none" strokeOpacity="0.25" />
      </svg>
    </div>
  )
}

export default VerticalTimeline
